import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { AboutMe } from './components/AboutMe';
import { MethodAER } from './components/MethodAER';
import { WorkWithMe } from './components/WorkWithMe';
import { FreeResources } from './components/FreeResources';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-inter text-plum-light selection:bg-orange/20 selection:text-plum" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <AboutMe data-id="element-5" />
        <MethodAER data-id="element-6" />
        <WorkWithMe data-id="element-7" />
        <FreeResources data-id="element-8" />
        <Testimonials data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}